import App from './App.svelte';
import { messages, version } from './swStore';

const app = new App({
  target: document.body,
});

function addMessage(msg) {
  messages.update((prev) => [...prev, msg]);
}

function sendMessage(message) {
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(message);
  }
  // const messageChannel = new MessageChannel();
  // This wraps the message posting/response in a promise, which will resolve if
  // the response doesn't contain an error, and reject with the error if it does.
  // If you'd prefer, it's possible to call controller.postMessage()
  // and set up the onmessage handler independently of a promise, but this is
  // a convenient wrapper.
  // return new Promise((resolve, reject) => {
  // messageChannel.port1.onmessage = function messageChannelHandler(event) {
  //   if (event.data.error) {
  //     addMessage(`Event error: ${event.data}`);
  //     reject(event.data.error);
  //   } else {
  //     addMessage(`Event data: ${event.data}`);
  //     resolve(event.data);
  //   }
  // };

  // This sends the message data as well as transferring messageChannel.port2
  // to the service worker.
  // The service worker can then use the transferred port to reply via postMessage(), which
  // will in turn trigger the onmessage handler on messageChannel.port1.
  // See https://html.spec.whatwg.org/multipage/workers.html#dom-worker-postmessage
  // console.log('Navigation.serviceWorker: ', navigator.serviceWorker);
  // if (!navigator.serviceWorker.controller) {
  //   reject(new Error('no controller available'));
  // }
  // navigator.serviceWorker.controller.postMessage(message, [
  //   messageChannel.port2,
  // ]);
  // });
}

let messageCount = 0;
function handleSWMessage({ data }) {
  messageCount += 1;
  if (messageCount > 10) {
    navigator.serviceWorker.removeEventListener('message', handleSWMessage);
  }
  console.log('ServiceWorker message: ', data);
  if (data.indexOf('version:') === 0) {
    return version.update(() => data.split(':')[1]);
  }
  return addMessage(data);
}

if ('serviceWorker' in navigator) {
  // Uninstall service workers
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister()
    }
  });
}

// window.sendMessage = sendMessage;
if ('serviceWorkerFoo' in navigator) {
  navigator.serviceWorker.addEventListener('message', handleSWMessage);

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js').then((reg) => {
      // console.log('Reg: ', reg);
      // reg.installing; // the installing worker, or undefined
      // reg.waiting; // the waiting worker, or undefined
      // reg.active; // the active worker, or undefined

      reg.addEventListener('updatefound', () => {
        // A wild service worker has appeared in reg.installing!
        // alert('update found');
        const newWorker = reg.installing;

        console.log('NewWorker state: ', newWorker.state);
        addMessage(`updatefound: ${newWorker.state}`);
        // "installing" - the install event has fired, but not yet complete
        // "installed"  - install complete
        // "activating" - the activate event has fired, but not yet complete
        // "activated"  - fully active
        // "redundant"  - discarded. Either failed install, or it's been
        //                replaced by a newer version

        newWorker.addEventListener('statechange', () => {
          // alert(`New worker state change: ${newWorker.state}`);
          // newWorker.state has changed
          addMessage(`statechange: ${newWorker.state}`);
        });
      });
    });
  });

  // First, do a one-off check if there's currently a
  // service worker in control.
  if (navigator.serviceWorker.controller) {
    console.log(navigator.serviceWorker.controller);

    // sendMessage('getVersion:current');
    addMessage(
      `This page is currently controlled by: ${navigator.serviceWorker.controller.state}`,
    );
  }

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log(navigator.serviceWorker.controller);
    addMessage(
      `This page is now controlled by: ${navigator.serviceWorker.controller.state}`,
    );
    // This fires when the service worker controlling this page
    // changes, eg a new worker has skipped waiting and become
    // the new active worker.
  });
}

export default app;
